import { SHOW_GENERAL_ERROR, HIDE_GENERAL_ERROR, CLOSE_DROP_DOWN_ON_SCHEDULE_SUCCESS, OPEN_MODAL_SUCCEEDED, HANDLE_SCHEDULE_TICKET_CLICK_SUCCEEDED } from '../actions/types';

const initialState = {
    openModal: false,
    scheduleInteraction: {}
};


export default function (state = initialState, action) {
    switch (action.type) {
        case SHOW_GENERAL_ERROR:
        case HIDE_GENERAL_ERROR:
            return action.payload
        case CLOSE_DROP_DOWN_ON_SCHEDULE_SUCCESS:
            return {
                ...state,
                ...action.payload
            }
        case OPEN_MODAL_SUCCEEDED:
            return {
                ...state,
                openModal: action.payload
            }
        case HANDLE_SCHEDULE_TICKET_CLICK_SUCCEEDED:
            return {
                ...state,
                scheduleInteraction: action.payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/general.reducer.js